import React from 'react';
import { Navigate } from 'react-router-dom';
import DashboardLayout from 'src/layouts/DashboardLayout';
import MainLayout from 'src/layouts/MainLayout';
import CustomerListView from 'src/views/customer/CustomerListView';
import DashboardView from 'src/views/reports/DashboardView';
import LoginView from 'src/views/auth/LoginView';
import NotFoundView from 'src/views/errors/NotFoundView';
import NotAuthenticatedView from './views/errors/NotAuthenticatedView';
import ProductListView from 'src/views/product/ProductListView';
import RegisterView from 'src/views/auth/RegisterView';
import SettingsView from 'src/views/settings/SettingsView';
import WorkList from './views/workrequest/WorkList';
import WorkerDemanderManagement from './views/workerdemander/WorkerDemanderManagement';
import AssetManagement from './views/asset/assetmanagement';
import LandingPage from './intro/LandingPage';
import WorkerRegister from "./views/worker/WorkerRegistrationForms/WorkerRegister";
import WorkerManagement from './views/worker/WorkerManagement';
import Agenda from './views/agenda/Agenda'; 
import WorkHour from './views/workrequest/WorkHour'; 
import EquipmentForm from './views/asset/EquipmentForm';
import EquipmentRentingForm from './views/asset/EquipmentRentingForm';
import VehicleForm from './views/asset/VehicleForm';
import VehicleRentingForm from './views/asset/VehicleRentingForm';
import WorkRequest from './views/workerdemander/WorkRequestForm/WorkRequest';
import WorkerDemanderProfile from './views/workerdemander/WorkerDemanderProfile/WorkerDemanderProfile';
import WorkRequestList from './views/workerdemander/WorkRequestList';

const routes = [
  {
    path: 'app',
    element: <DashboardLayout />,
    children: [
      { path: '/', element: <DashboardView/> }, 
      { path: 'customers', element: <CustomerListView /> },
      { path: 'dashboard', element: <DashboardView /> },
      { path: 'products', element: <ProductListView /> },
      { path: 'settings', element: <SettingsView /> },

      /* worker views */
      { path: 'worker_management', element: <WorkerManagement /> },
      { path: '/worker_profile/:id', element: <WorkerRegister /> },
      { path: '/worker_registration', element: <WorkerRegister /> },
      
      /* work request views */
      { path: 'work_list', element: <WorkList /> },

      /* worker demander views */
      { path: 'worker_demander_management', element: <WorkerDemanderManagement /> },
      { path: '/worker_demander_profile/:id', element: <WorkerDemanderProfile /> },
      { path: '/work_requests/:id', element: <WorkRequestList /> },
      { path: '/work_request/:id', element: <WorkRequest /> },
      { path: '/work_request', element: <WorkRequest /> },

      /* asset views */
      { path: 'asset_management', element: <AssetManagement /> },
      { path: 'equipment_form', element: <EquipmentForm /> },
      { path: 'equipment_renting_form', element: <EquipmentRentingForm /> },
      { path: 'vehicle_form', element: <VehicleForm /> },
      { path: 'vehicle_renting_form', element: <VehicleRentingForm /> },

      /* scheduling views */
      { path: 'agenda', element: <Agenda /> },
      { path: 'work_hour', element: <WorkHour /> },

      { path: '*', element: <Navigate to="/404" /> }
    ]
  },
  
  {
    path: '/',
    element: <MainLayout/>,
    children: [
      { path: '/', element:<LandingPage/> }, 

      { path: '/login', element: <LoginView/> },
      { path: '/logout', element: <LandingPage/> },
      { path: '/register', element: <RegisterView /> },

      { path: '/worker_registration', element: <WorkerRegister /> },
      { path: '/worker_registration/:id', element: <WorkerRegister /> },
      { path: '/work_request', element: <WorkRequest /> },
      
      { path: '404', element: <NotFoundView /> }, 
      { path: '/401', element: <NotAuthenticatedView /> }, 
      { path: '*', element: <Navigate to="/404" /> }
    ]
  } 
];

export default routes;
